import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import styled from 'styled-components';
import { residentialPageQuery } from '../queries';

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: #2E5984;
  margin-bottom: 1rem;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
  white-space: pre-line;
`;

const Residential = () => {
  const defaultData = {
    title: "Residential Care",
    subtitle: "Comfortable and caring environment",
    eligibilityHeader: "Eligibility",
    eligibilityText: "When entering residential care the government requires anyone wishing to access care to be assessed by the Aged Care Assessment Team (ACAT). Your application cannot be considered without an ACAT approval. Aged Care Assessment Team phone number is 03 6464 3070, or click on the link above. Alternatively contact My Aged Care on 1800 200 422 to arrange an assessment.",
    costHeader: "Cost",
    costText: "Charges are regulated by the Federal Government. Refer our Fees & Charges page for more information."
  };

  const customContent = (pageData) => (
    <>
      <Section>
        <SectionTitle>
          {pageData.eligibilityHeader}
        </SectionTitle>
        <Paragraph>
          {pageData.eligibilityText}
        </Paragraph>
      </Section>
      
      <Section>
        <SectionTitle>
          {pageData.costHeader}
        </SectionTitle>
        <Paragraph>
          {pageData.costText}
        </Paragraph>
      </Section>
    </>
  );

  return (
    <StaticPageTemplate
      pageName="residentialPage"
      query={residentialPageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default Residential;
